import Env from "../base/env";
import Channels from "../base/channels";
import gsap from "gsap";
import { SplitText } from "../vendor/gsap-bonus-umd/SplitText";
gsap.registerPlugin(SplitText);

export default () => ({
  ref: Env.$mainnav,
  items: Env.$mainnav.querySelectorAll(".css-entry"),
  itemsHoverTxt: Env.$mainnav.querySelectorAll(".js-hover-text"),
  subnavItems: Env.$mainnav.querySelectorAll(".css-subnav"),
  fxHoverTxt: {
    out: [],
    in: [],
  },
  init() {
    // gsap.delayedCall(0.1, () => {
    //   if (Env.mobileCSS == false) {
    //     this.prepareFx();
    //   }
    // });
  },
  prepareFx() {
    for (let hoverTxt of this.itemsHoverTxt) {
      const DOM = {
        textOut: hoverTxt.querySelector(".txt-out"),
        textIn: hoverTxt.querySelector(".txt-in"),
      };
      DOM.textIn.innerHTML = DOM.textOut.innerHTML;
      // prettier-ignore
      const instanceOut = new SplitText(DOM.textOut, { type: "words", wordsClass:"tw-overflow-hidden" });
      // prettier-ignore
      const instanceOutAlt = new SplitText(DOM.textOut, { type: "words", wordsClass:"fx-hovertext-out" });
      // prettier-ignore
      const instanceIn = new SplitText(DOM.textIn, { type: "words", wordsClass:"tw-overflow-hidden" });
      // prettier-ignore
      const instanceInAlt = new SplitText(DOM.textIn, { type: "words", wordsClass:"fx-hovertext-in" });

      this.fxHoverTxt.out.push(instanceOut);
      this.fxHoverTxt.in.push(instanceIn);
    }
  },
  events() {
    Channels.on("subnav::opened", () => {
      this.emitSubnavOpened();
    });
    Channels.on("mainnav::opened", () => {
      this.emitNavOpened();
    });
    Channels.on("mainnav::closed", () => {
      this.emitNavClosed();
    });
  },
  emitNavClosed() {
    this.emitSubnavClosed();
    this.closeAllSubnav();
    Env.$html.classList.remove("mainnav-opened");
  },
  closeAllSubnav(check) {
    for (const item of this.items) {
      if (check != item) {
        this.closeSubnavItem(item);
      }
    }
  },
  closeAllPreviews(check) {
    console.log();
    const getBlockPreviewItems = check.parentElement.querySelectorAll("li");
    for (const item of getBlockPreviewItems) {
      if (check != item) {
        this.closePreviewItem(item);
      }
    }
  },
  checkSubnav() {
    for (let item of this.items) {
      if (item.classList.contains("is-active")) {
        this.emitSubnavOpened();
        break;
      }
    }
  },
  closeSubnavItem(item) {
    this.emitSubnavClosed();
    item.classList.remove("is-active");
  },
  closePreviewItem(item) {
    item.classList.remove("is-visible");
  },
  emitNavOpened() {
    Env.$html.classList.add("mainnav-opened");
  },
  emitSubnavClosed() {
    Env.$html.classList.remove("subnav-opened");
  },
  emitSubnavOpened() {
    Env.$html.classList.add("subnav-opened");
  },
  openSubnavItem(item) {
    // gsap.delayedCall(0.1, () => {
    //   this.emitSubnavOpened();
    // });

    if (Env.mobileCSS) {
      item.classList.add("is-active");
    } else {
      item.classList.toggle("is-active");
      this.closeAllSubnav(item);
    }
    this.checkSubnav();
  },
  openPreviewItem(item) {
    if (Env.mobileCSS == false) {
      item.classList.add("is-visible");
      this.closeAllPreviews(item);
    }
  },
});
